import { GridContainer, GridItem, InformationField, InformationPad } from '../shared';
import { Box, Paper, Typography } from '@mui/material';
import { Link } from '../shared';
import useStyles from './style';
import { routeConstants } from '../../constants/routeConstants';
import { getCurrency } from '../../utils/common-methods';
import dayjs from 'dayjs';
import { ASSET_STATUS } from '../../constants/assetStatus';

const STATUS_ID_TO_NAME = Object.entries(ASSET_STATUS).reduce((acc, [key, value]) => {
  acc[value] = key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
  return acc;
}, {});

const MachineAccordion = ({ machineInfo }) => {
  const classes = useStyles();
  if (machineInfo) {
    machineInfo = {
      ...machineInfo,
      price: machineInfo?.price || 0,
      installedDate: machineInfo?.installedDate || null,
    };
  }

  const { asset, assetHistories } = machineInfo || {};
  const statusId = assetHistories?.[0]?.statusId ?? asset?.statusId ?? machineInfo?.statusId;
  const numberOfPlays = assetHistories?.[0]?.numberOfPlays || machineInfo?.numberOfPlays;
  const installedDate = asset?.installedDate || machineInfo?.installedDate;
  const modelTitle = asset?.model?.title || machineInfo?.modelTitle;
  const price = assetHistories?.[0]?.price ?? machineInfo?.price ?? 0;
  const sublocationName = assetHistories?.[0]?.sublocation?.name || machineInfo?.sublocationName;

  const fields = [
    {
      label: 'Status',
      value: STATUS_ID_TO_NAME[statusId] || statusId || 'N/A', // Same pattern
    },
    { label: 'No.of Plays', value: numberOfPlays || 0 },
    {
      label: 'Installed Date',
      value: installedDate ? dayjs(installedDate).format('MM/DD/YYYY') : installedDate,
    },
    { label: 'Model Name', value: modelTitle },
    {
      label: 'Price',
      value: `${getCurrency(machineInfo?.currency?.abbreviation || 'USD')} ${price}`,
    },
    {
      label: 'Sub Location',
      value: sublocationName,
    },
  ];
  const id = machineInfo?.id?.props?.children;
  return (
    <Box component={Paper} className={classes.machineAccordion}>
      <GridContainer>
        <GridItem xs={12} md={12}>
          <Typography variant="h3" mb={1}>
            Machine Details
          </Typography>
        </GridItem>
      </GridContainer>
      <InformationPad data={fields} />
      <GridContainer className={classes.machineAccordionBtnWrap}>
        <GridItem xs={12} md={12}>
          <InformationField
            fontSize="14px"
            fontWeight="500"
            lineHeight="16px"
            value={
              <Link
                variant="link"
                underline="none"
                color="primary"
                to={`/${routeConstants.MACHINES_ROUTE}/${id || machineInfo?.id}`}
              >
                VIEW FULL DETAILS
              </Link>
            }
          />
        </GridItem>
      </GridContainer>
    </Box>
  );
};

export default MachineAccordion;
